module.exports = __webpack_public_path__ + "img/138.7.0d391eba.png";